import styled, { css } from 'styled-components';
import { CalendarBlank } from '@phosphor-icons/react';

import { FormElementThemeColor, StyledFormElements, formElementThemes } from '@tmh-website/ui/FormElements';
import StyledTypo from '@tmh-website/styles/typo';

export const Input = styled(StyledFormElements.Input)`
  height: 0;
  overflow: hidden;

  ${props =>
    !props.disabled &&
    css`
      cursor: pointer;
    `};

  /* handling native datepicker shadow root styles */
  &::-webkit-datetime-edit-fields-wrapper {
    ${StyledTypo.uiTextCss};
    font-size: 16px;

    /* apply custom letter spacing only on safari */
    @supports (hanging-punctuation: first) and (font: -apple-system-body) and (-webkit-appearance: none) {
      letter-spacing: -0.5px;
    }

    &::-webkit-datetime-edit-text {
      margin-right: -0.5px;
      margin-left: -0.5px;
    }
  }

  &::-webkit-calendar-picker-indicator {
    display: none;
  }
`;

export const Icon = styled(CalendarBlank)`
  margin: 0 10px 0 0;
  opacity: 0.4;
  transition: opacity ${props => props.theme.transitionTiming};
`;

export const Container = styled(StyledFormElements.Container)`
  overflow: hidden;

  ${props =>
    !props.$isDisabled &&
    css`
      cursor: pointer;

      &:hover {
        ${Icon} {
          opacity: 1;
        }
      }
    `};
`;

// TODO: This is here because there currently is no way to hide the icon in Firefox. Remove when fixed.
// @see https://bugzilla.mozilla.org/show_bug.cgi?id=1812397
export const FirefoxIconHider = styled.div<{ $themeColor: FormElementThemeColor }>`
  position: absolute;
  right: 58px;
  bottom: 0;
  width: 36px;
  height: 36px;
  background-color: ${props => props.theme.color[formElementThemes[props.$themeColor].background.normal]};
`;
